module.exports = __webpack_public_path__ + "img/dashboard.347bc29d.svg";